import { useState, useEffect } from 'react';
import { Fetcher } from 'a-fetch';
export { Client, Fetcher, Router } from 'a-fetch';
import { get } from 'js-expansion';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Config = /*#__PURE__*/function () {
  function Config(api) {
    this.Request = api ? Fetcher.api(api) : Fetcher.request();
    this.setRecords = null;
    this._mapping = {};
    this._headers = {};
    this._data = null;
  }

  var _proto = Config.prototype;

  _proto.index = function index(name, params, headers) {
    var _this = this;

    if (params === void 0) {
      params = {};
    }

    if (headers === void 0) {
      headers = {};
    }

    var _useState = useState({
      params: params,
      append: false,
      skip: !!this._data
    }),
        indexParams = _useState[0],
        setIndexParams = _useState[1];

    var _useState2 = useState(_extends({}, Fetcher.collection(), {
      data: this._data || Fetcher.collection().data
    })),
        index = _useState2[0],
        setIndex = _useState2[1];

    useEffect(function () {
      if (indexParams.skip) {
        return;
      }

      setIndex(_extends({}, index, {
        loading: true
      }));

      _this.Request.index(name, indexParams.params, headers || _this._headers).then(function (response) {
        if (indexParams.append) {
          response.data = index.data.concat(response.data);
        }

        setIndex(response);

        if (_this.setRecords && response.records) {
          _this.setRecords(response.records);
        }
      });
    }, [indexParams.params]);
    return [index, function (data) {
      return setIndex(_extends({}, index, {
        data: data
      }));
    }, indexParams.params, function (params, append) {
      if (append === void 0) {
        append = false;
      }

      return setIndexParams({
        params: params,
        append: append,
        skip: false
      });
    }];
  };

  _proto.show = function show(name, params, headers) {
    var _this2 = this;

    if (params === void 0) {
      params = {};
    }

    if (headers === void 0) {
      headers = {};
    }

    var _useState3 = useState(params),
        showParams = _useState3[0],
        setShowParams = _useState3[1];

    var _useState4 = useState(Fetcher.model()),
        show = _useState4[0],
        setShow = _useState4[1];

    useEffect(function () {
      setShow(_extends({}, show, {
        loading: true
      }));

      _this2.Request.show(name, showParams, headers || _this2._headers).then(function (response) {
        setShow(response);

        if (_this2.setRecords && response.records) {
          _this2.setRecords(response.records);
        }
      });
    }, [showParams]);
    return [show, function (data) {
      return setShow(_extends({}, show, {
        data: data
      }));
    }, showParams, setShowParams];
  };

  _proto.store = function store(name, model, headers) {
    var _this3 = this;

    if (model === void 0) {
      model = {};
    }

    if (headers === void 0) {
      headers = {};
    }

    var _useState5 = useState(_extends({}, Fetcher.model(), {
      loading: false,
      data: model,
      submitting: false
    })),
        store = _useState5[0],
        setStore = _useState5[1];

    var submit = function submit(submitParams) {
      if (submitParams === void 0) {
        submitParams = {};
      }

      setStore(_extends({}, store, {
        submitting: true
      }));

      var data = _extends({}, store.data, submitParams);

      return _this3.Request.store(name, data, headers || _this3._headers).then(function (response) {
        var errors = response.errors || [];
        setStore(_extends({}, store, response, {
          errors: errors,
          data: errors.length ? _extends({}, data) : _extends({}, data, _this3.getData(response.data, model)),
          submitting: false
        }));

        if (_this3.setRecords && response.records) {
          _this3.setRecords(response.records);
        }

        return response;
      });
    };

    return [store, function (data, errors) {
      if (errors === void 0) {
        errors = null;
      }

      return setStore(_extends({}, store, {
        errors: Array.isArray(errors) ? errors : store.errors,
        data: _extends({}, store.data, data)
      }));
    }, submit];
  };

  _proto.getData = function getData(response, model, data) {
    var _this4 = this;

    if (data === void 0) {
      data = {};
    }

    Object.keys(model).map(function (name) {
      if (_this4._mapping[name]) {
        if (typeof _this4._mapping[name] === 'function') {
          data[name] = _this4._mapping[name](response);
        } else {
          data[name] = get(response, _this4._mapping[name]) || '';
        }
      } else if (response.hasOwnProperty(name)) {
        if (model[name] && !Array.isArray(model[name]) && typeof model[name] === 'object' && Object.keys(model).length > 0) {
          data[name] = _this4.getData(response[name], model[name]);
        } else {
          data[name] = response[name];
        }
      }
    });
    return data;
  };

  _proto.update = function update(name, model, params, headers) {
    var _this5 = this;

    if (model === void 0) {
      model = {};
    }

    if (params === void 0) {
      params = {};
    }

    if (headers === void 0) {
      headers = {};
    }

    var hasParams = Boolean(Object.keys(params).length);

    var _useState6 = useState(_extends({}, Fetcher.model(), {
      loading: hasParams,
      data: model
    })),
        update = _useState6[0],
        setUpdate = _useState6[1];

    var updateData = function updateData(data, errors) {
      if (errors === void 0) {
        errors = null;
      }

      return setUpdate(_extends({}, update, {
        loading: false,
        submitting: false,
        errors: Array.isArray(errors) ? errors : update.errors,
        data: _extends({}, update.data, data)
      }));
    };

    if (hasParams) {
      useEffect(function () {
        _this5.Request.show(name, params, headers || _this5._headers).then(function (response) {
          updateData(_this5.getData(response.data, model));
        });
      }, []);
    }

    var submit = function submit(submitParams) {
      if (submitParams === void 0) {
        submitParams = {};
      }

      setUpdate(_extends({}, update, {
        errors: [],
        submitting: true
      }));

      var data = _extends({}, update.data, submitParams);

      return _this5.Request.update(name, data, headers || _this5._headers).then(function (response) {
        var errors = response.errors || [];
        setUpdate(_extends({}, update, response, {
          errors: errors,
          data: errors.length ? _extends({}, data) : _extends({}, data, _this5.getData(response.data, model)),
          submitting: false
        }));

        if (_this5.setRecords && response.records) {
          _this5.setRecords(response.records);
        }

        return response;
      });
    };

    return [update, updateData, submit];
  };

  _proto["delete"] = function _delete(name, params, headers) {
    var _this6 = this;

    if (params === void 0) {
      params = {};
    }

    if (headers === void 0) {
      headers = {};
    }

    var _useState7 = useState({
      loading: false,
      submitting: false
    }),
        destroy = _useState7[0],
        setDestroy = _useState7[1];

    var submit = function submit(submitParams) {
      if (submitParams === void 0) {
        submitParams = {};
      }

      setDestroy({
        submitting: true
      });
      return _this6.Request["delete"](name, _extends({}, params, submitParams), headers || _this6._headers).then(function (response) {
        setDestroy({
          submitting: false
        });

        if (_this6.setRecords && response.records) {
          _this6.setRecords(response.records);
        }

        return response;
      });
    };

    return [destroy, submit];
  };

  _proto.login = function login(model, headers) {
    var _this7 = this;

    if (headers === void 0) {
      headers = {};
    }

    var _useState8 = useState(_extends({}, Fetcher.model(), {
      loading: false,
      submitting: false,
      data: model
    })),
        login = _useState8[0],
        setLogin = _useState8[1];

    var submit = function submit(submitParams) {
      if (submitParams === void 0) {
        submitParams = {};
      }

      setLogin(_extends({}, login, {
        submitting: true
      }));
      return _this7.Request.login(_extends({}, login.data, submitParams), headers || _this7._headers).then(function (response) {
        setLogin(_extends({}, login, response, {
          data: login.data,
          submitting: false
        }));
        return response;
      });
    };

    return [login, function (data) {
      return setLogin(_extends({}, login, {
        data: _extends({}, login.data, data)
      }));
    }, submit];
  };

  _proto.logout = function logout(model, headers) {
    var _this8 = this;

    if (headers === void 0) {
      headers = {};
    }

    var _useState9 = useState(_extends({}, Fetcher.model(), {
      loading: false,
      submitting: false,
      data: model
    })),
        logout = _useState9[0],
        setLogout = _useState9[1];

    var submit = function submit() {
      setLogout(_extends({}, logout, {
        submitting: true
      }));
      return _this8.Request.logout(logout.data, headers || _this8._headers).then(function (response) {
        setLogout(_extends({}, logout, response, {
          data: model,
          submitting: false
        }));
        return response;
      });
    };

    return [logout, function (data) {
      return setLogout(_extends({}, logout, {
        data: _extends({}, logout.data, data)
      }));
    }, submit];
  };

  _proto.data = function data(_data) {
    this._data = _data;
    return this;
  };

  _proto.records = function records(setRecords, _records, value_key, records_key) {
    if (setRecords === void 0) {
      setRecords = null;
    }

    if (_records === void 0) {
      _records = [];
    }

    if (value_key === void 0) {
      value_key = 'id';
    }

    if (records_key === void 0) {
      records_key = 'id';
    }

    this.setRecords = setRecords;
    this.Request.records(_records, value_key, records_key);
    return this;
  };

  _proto.mapping = function mapping(_mapping) {
    if (_mapping === void 0) {
      _mapping = {};
    }

    this._mapping = _mapping;
    return this;
  };

  _proto.headers = function headers(_headers) {
    if (_headers === void 0) {
      _headers = {};
    }

    this._headers = _headers;
    return this;
  };

  _proto.api = function api(_api) {
    this.Request.api(_api);
    return this;
  };

  _proto.bearerToken = function bearerToken(bearer_token) {
    this.Request.bearerToken(bearer_token);
    return this;
  };

  return Config;
}();

var useApi = function useApi(name) {
  return new Config(name);
};
var useBearerToken = function useBearerToken(name) {
  return new Config().bearerToken(name);
};
var useRecords = function useRecords(setRecords, records, key) {
  if (setRecords === void 0) {
    setRecords = null;
  }

  if (records === void 0) {
    records = [];
  }

  if (key === void 0) {
    key = 'id';
  }

  return new Config().records(setRecords, records, key);
};
var useData = function useData(data) {
  return new Config().data(data);
};
var useMapping = function useMapping(mapping) {
  if (mapping === void 0) {
    mapping = {};
  }

  return new Config().mapping(mapping);
};
var useHeaders = function useHeaders(headers) {
  if (headers === void 0) {
    headers = {};
  }

  return new Config().headers(headers);
};
var useIndex = function useIndex(name, params, headers) {
  if (params === void 0) {
    params = {};
  }

  if (headers === void 0) {
    headers = {};
  }

  return new Config().index(name, params, headers);
};
var useShow = function useShow(name, params, headers) {
  if (params === void 0) {
    params = {};
  }

  if (headers === void 0) {
    headers = {};
  }

  return new Config().show(name, params, headers);
};
var useStore = function useStore(name, model, headers) {
  if (model === void 0) {
    model = {};
  }

  if (headers === void 0) {
    headers = {};
  }

  return new Config().store(name, model, headers);
};
var useUpdate = function useUpdate(name, model, params, headers) {
  if (model === void 0) {
    model = {};
  }

  if (params === void 0) {
    params = {};
  }

  if (headers === void 0) {
    headers = {};
  }

  return new Config().update(name, model, params, headers);
};
var useDelete = function useDelete(name, params, headers) {
  if (params === void 0) {
    params = {};
  }

  if (headers === void 0) {
    headers = {};
  }

  return new Config()["delete"](name, params, headers);
};
var useLogin = function useLogin(model, headers) {
  if (model === void 0) {
    model = {};
  }

  if (headers === void 0) {
    headers = {};
  }

  return new Config().login(model, headers);
};
var useLogout = function useLogout(model, headers) {
  if (model === void 0) {
    model = {};
  }

  if (headers === void 0) {
    headers = {};
  }

  return new Config().logout(model, headers);
};

export { useApi, useBearerToken, useData, useDelete, useHeaders, useIndex, useLogin, useLogout, useMapping, useRecords, useShow, useStore, useUpdate };
//# sourceMappingURL=index.modern.js.map
